import type { FunctionComponent } from "react";
import { Text } from "@smartsuite/react-ui/lib";
import type { Preferences } from "@smartsuite/types/lib/models/preferences";

import { TextFieldWrapper } from "../TextFieldWrapper/TextFieldWrapper";
import {
  formatDateByUserPreferences,
  getTimeFormatByUserPreferences,
} from "../../../../../utils/date";

interface DateFieldProps {
  value: string;
  userPreferences: Preferences;
}

export const DateField: FunctionComponent<DateFieldProps> = ({
  value,
  userPreferences,
}) => {
  const date = new Date(value);
  const formattedDate = `${formatDateByUserPreferences(
    date,
    userPreferences.timezone.value,
    "MMM D, yyyy",
  )} at ${formatDateByUserPreferences(
    date,
    userPreferences.timezone.value,
    getTimeFormatByUserPreferences(userPreferences),
  )}`;
  return (
    <TextFieldWrapper>
      <Text>{formattedDate}</Text>
    </TextFieldWrapper>
  );
};
